/**
 * Sample React Native App
 * https://github.com/facebook/react-native
 *
 * @format
 * @flow strict-local
 */

import * as eva from '@eva-design/eva';
import {ApplicationProvider, IconRegistry, Layout} from '@ui-kitten/components';
import {EvaIconsPack} from '@ui-kitten/eva-icons';
import React from 'react';
import {StyleSheet, View, Image, Text} from 'react-native';
import {Provider} from 'react-redux';
import {PersistGate} from 'redux-persist/integration/react';
import {default as theme} from './assets/json/custom-theme.json'; // <-- Import app theme
import uiKittenMapping from './assets/json/uiKittenMapping.json';
import {
  default as navigator,
  default as NavigatorService,
} from './helpers/navigator';
import AppNavigator from './navigation/AppNavigator';
import {UN_AUTHENTICATED_ROUTES} from './navigation/constants';
import {checkJWT} from './redux/actions';
import {persistor, store} from './redux/configs';
import {isLandscape, px} from './utils';

import {isChrome} from 'react-device-detect';
import {renderIfElse} from './utils/Utils';
import {chromeIcon} from './assets/images';

class App extends React.Component {
  state = {
    isLoadingComplete: false, // set to true after app resources are loaded
    navigatorServiceContainerSet: false,
  };

  componentDidUpdate() {
    const isAuthenticated = Boolean(store.getState().auth.accessToken);
    if (isAuthenticated && this.state.navigatorServiceContainerSet) {
      checkJWT().catch(() =>
        navigator.navigateTo(UN_AUTHENTICATED_ROUTES.welcomeScreen.path),
      );
    }
  }
  render() {
    return (
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <IconRegistry icons={EvaIconsPack} />
          <ApplicationProvider
            {...eva}
            customMapping={uiKittenMapping}
            theme={{...eva.light, ...theme}}>
            <Layout style={styles.container}>
              {renderIfElse(
                isChrome,
                <AppNavigator
                  ref={(navigatorRef) => {
                    NavigatorService.setContainer(navigatorRef);
                    if (!this.state.navigatorServiceContainerSet) {
                      this.setState({navigatorServiceContainerSet: true});
                    }
                  }}
                />,
                <View style={styles.notSupportText}>
                  <Image
                    style={styles.chromeIcon}
                    source={chromeIcon}
                    resizeMode="contain"
                  />
                  <Text style={styles.flexView}>
                    Kindly open in Google Chrome browser
                  </Text>
                </View>,
              )}
            </Layout>
          </ApplicationProvider>
        </PersistGate>
      </Provider>
    );
  }
}
const styles = StyleSheet.create({
  container: {
    height: isLandscape() ? '100vh' : '90vh',
    width: '100%',
  },
  flexView: {
    flex: 1,
  },
  notSupportText: {
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 24,
    paddingHorizontal: px(15),
  },
  chromeIcon: {
    marginTop: 200,
    marginBottom: px(10),
    width: 50,
    height: 50,
  },
});

export default App;
